module.exports = __webpack_public_path__ + "static/media/newlogo2.8d66142d.png";